import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClockErrorWithExclamationColored(
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 53 50" {...props}>
      <g clipPath="url(#clip0_clock_error_exclamation)">
        <circle
          cx={27.957}
          cy={24.9804}
          r={24.9804}
          stroke="url(#paint0_clock_error_exclamation)"
          strokeWidth={9.992_16}
        />
        <path
          stroke="#82090F"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M27.957 21.064V25.4511L31.957 29.064"
        />
        <path
          stroke="#82090F"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M18.707 18.064V22.064H22.707"
        />
        <path
          stroke="#82090F"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.207 28.7306C20.4787 32.4204 23.9101 35.064 27.9435 35.064C33.0596 35.064 37.207 30.8107 37.207 25.564C37.207 20.3173 33.0596 16.064 27.9435 16.064C24.1051 16.064 20.812 18.458 19.4065 21.8695"
        />
      </g>
      <rect
        x={0.196_721}
        y={0.502_873}
        width={15.3442}
        height={15.0775}
        rx={7.538_74}
        fill="#B01921"
      />
      <rect
        x={0.196_721}
        y={0.502_873}
        width={15.3442}
        height={15.0775}
        rx={7.538_74}
        stroke="#fff"
        strokeWidth={0.393_441}
      />
      <path
        fill="#fff"
        d="M8.08949 8.79285H7.68582L7.50169 6.48413V5.11024H8.26654V6.48413L8.08949 8.79285ZM8.27362 10.1738H7.50169V9.4019H8.27362V10.1738Z"
      />
      <defs>
        <linearGradient
          id="paint0_clock_error_exclamation"
          x1={27.957}
          y1={0}
          x2={27.7421}
          y2={37.737}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195_043} stopColor="#FFC8C8" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <clipPath id="clip0_clock_error_exclamation">
          <rect x={2.976_56} width={49.9608} height={49.9608} rx={24.9804} fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgClockErrorWithExclamationColored);
export default ForwardRef;
